export default {
  PRODUCTION: true,
  DICEBEAR_API_URL: 'https://schnapsen.online/api/dicebear/9.x/adventurer/svg',
};
